import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout/Layout";

import '../index.css'
import '../fonts.css'

// variable "slug" comes from context which we pointed
// in gatsby-node createPage function
export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
      }
      html
    }
  }
`

const SiteDocumentation = props => {
  return (
    <Layout darkColor>
        <div
          className="wrapper"
          dangerouslySetInnerHTML={{ __html: props.data.markdownRemark.html }}
        />
    </Layout>
  )
}

export default SiteDocumentation